import AllergenNotice from "./AllergenNotice";

export default AllergenNotice;
